// extracted by mini-css-extract-plugin
export default {"cls1":"AccountMenu-cls1__f8406f94d2d6d7b017e4","cls2":"AccountMenu-cls2___18cf4f8b7aecfe11e28 AccountMenu-cls1__f8406f94d2d6d7b017e4"};